export class AmenityCategories {
    get consoleUrl(): string {
        return `/settings/amenity-categories`;
    }
}
